import { ClinicalPolicyDialog as CPDialog, type Question } from '@strata/react-question-tree';
import { useEffect, useState } from 'react';

import { getQuestionTree } from 'api/clinicalPolicyAPI';
import { handleError } from 'services/Error';
import { useAppSelector } from 'store';
import { type ReferralDetails } from 'store/api/treatmentApi';

interface ClinicalPolicyDialogProps {
    referralDetails?: ReferralDetails;
    isOpen: boolean;
    onClose: () => void;
}

export const ClinicalPolicyDialog = ({
    referralDetails = undefined,
    isOpen,
    onClose,
}: ClinicalPolicyDialogProps) => {
    const { payerId } = useAppSelector((state) => state.auth);

    const [questions, setQuestions] = useState<Question[]>();
    useEffect(() => {
        if (isOpen) {
            void (async () => {
                try {
                    if (referralDetails?.productServiceOid && referralDetails?.diagnosisOid) {
                        const questionPayload = await getQuestionTree({
                            payerId: payerId!,
                            productServiceOid: referralDetails.productServiceOid,
                            diagnosisOid: referralDetails.diagnosisOid,
                        });
                        setQuestions(questionPayload.nodes);
                    }
                } catch (err) {
                    onClose();
                    handleError('An error occurred retrieving clinical policy.', err as Error);
                }
            })();
        }
    }, [isOpen, onClose, payerId, referralDetails]);

    return (
        <CPDialog
            isOpen={isOpen}
            onClose={onClose}
            questions={questions}
            answers={referralDetails?.clinicalInfo?.clinicalPolicyAnswers}
        />
    );
};
